var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 446,
    viewBox: "0 0 467 446",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467.142 158.877C438.795 183.337 407.81 203.411 374.934 221.343C333.59 243.894 292.673 266.977 248.85 284.486C208.141 300.752 167.858 315.294 128.932 335.706C104.926 348.294 81.5121 364.213 59.962 380.624C48.9633 389 39.7104 396.263 29.8785 406C15.2181 420.519 10.5 425.5 1.5 444",
    stroke: "#C9C1AE",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 443.288C92.4196 412.019 147.388 397.406 194.828 378.018C259.683 351.512 306.687 308.941 338.988 246.646C364.354 197.726 385.508 146.865 412.065 98.4995C438.622 50.1338 467.5 1.5 467.5 1.5",
    stroke: "#650D1B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutLine2);
export default __webpack_public_path__ + "static/media/aboutLine2.578e98c6f2899d2c2f26afde11cfc712.svg";
export { ForwardRef as ReactComponent };